import { TFunction } from 'i18next'

import { UnitDetails } from '@/models/features'

import { formatAddress } from './unit-general.page.utils'

export const GENERAL_EMPTY_VALUE = '—'

export interface UnitGeneralField {
  key: string
  label: string
  value: string | null
}

interface GetUnitGeneralFieldsProps {
  t: TFunction<['units']>
  unit?: UnitDetails | null
}

export const getUnitGeneralFields = ({
  t,
  unit,
}: GetUnitGeneralFieldsProps): UnitGeneralField[] => [
  {
    key: 'address',
    label: t('units:detail.general.fields.address'),
    value: formatAddress(unit),
  },
  {
    key: 'zipCode',
    label: t('units:detail.general.fields.zipCode'),
    value: unit?.zip ?? null,
  },
  {
    key: 'buildingName',
    label: t('units:detail.general.fields.buildingName'),
    value: unit?.buildingName ?? null,
  },
  {
    key: 'buildingNumber',
    label: t('units:detail.general.fields.buildingNumber'),
    value: unit?.buildingNumber ?? null,
  },
  { key: 'floor', label: t('units:detail.general.fields.floor'), value: unit?.floor ?? null },
  { key: 'unit', label: t('units:detail.general.fields.unit'), value: unit?.unit ?? null },
  {
    key: 'unitType',
    label: t('units:detail.general.fields.unitType'),
    value: unit?.unitType ?? null,
  },
  {
    key: 'squareFeet',
    label: t('units:detail.general.fields.squareFeet'),
    value:
      unit?.squareFeet == null
        ? null
        : t('units:detail.general.squareFeetValue', { value: unit.squareFeet }),
  },
]
